import { Flex, Tag } from 'antd';
import { useTranslation } from 'translations/hooks';

type ParameterCountTagProps = {
  display?: boolean;
  displayTitle?: boolean;
  selectedParameterCount: number;
  maxParameters?: number;
};

export const ParameterCountTag = ({
  display = true,
  displayTitle = false,
  maxParameters,
  selectedParameterCount,
}: ParameterCountTagProps) => {
  const { t } = useTranslation();

  if (!display) {
    return null;
  }

  return (
    <Flex gap={8} align="center" style={{ fontSize: 14 }}>
      {displayTitle ? t('dataAnalysis.labels.parameters') : null}
      <Tag color="geekblue" bordered={false}>
        {selectedParameterCount}
        {maxParameters ? `/${maxParameters}` : null}
      </Tag>
    </Flex>
  );
};
